/**
 * Bevimi cart drawer – separate customizations (no core overrides).
 * Sets drawer heading to "Cart" and wires "Clear all" (Figma 1282-884) via Ajax API.
 * Product column header is left to theme Liquid (e.g. Product) so one-time lines
 * are not labeled as subscriptions.
 */
(function () {
  const CART_HEADING = 'Cart';

  function applyBevimiLabels() {
    const headingEl = document.querySelector('cart-drawer .drawer__heading');
    if (headingEl && headingEl.textContent.trim() !== CART_HEADING) {
      headingEl.textContent = CART_HEADING;
    }
  }

  /**
   * Hide the whole <dl> when it only contains "Default: Default" (default variant option).
   * Dawn outputs this from item.options_with_values when product has one variant.
   */
  function hideDefaultVariantDl() {
    const dls = document.querySelectorAll('cart-drawer .cart-item__details dl');
    for (const dl of dls) {
      const options = dl.querySelectorAll('.product-option');
      const hasOnlyDefault = options.length === 1 &&
        options[0].querySelector('dt')?.textContent?.trim() === 'Default:' &&
        options[0].querySelector('dd')?.textContent?.trim() === 'Default';
      if (hasOnlyDefault) {
        dl.classList.add('cart-item__dl--default-variant-only');
      } else {
        dl.classList.remove('cart-item__dl--default-variant-only');
      }
    }
  }

  /**
   * Clear cart via POST /cart/clear.js, then refresh drawer and cart icon sections.
   */
  function clearCart() {
    const drawer = document.querySelector('cart-drawer');
    const clearBtn = document.querySelector('cart-drawer [data-cart-clear]');
    if (!drawer || !clearBtn || !window.shopUrl || !window.routes) return;

    clearBtn.setAttribute('aria-busy', 'true');
    clearBtn.disabled = true;

    const cartUrl = window.routes.cart_url || window.shopUrl + '/cart';
    const clearUrl = window.shopUrl + '/cart/clear.js';

    fetch(clearUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then(() => {
        return Promise.all([
          fetch(cartUrl + '?section_id=cart-drawer').then((r) => r.text()),
          fetch(cartUrl + '?section_id=cart-icon-bubble').then((r) => r.text()),
        ]);
      })
      .then(([drawerHtml, iconHtml]) => {
        const drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html');

        const newDrawerInner = drawerDoc.querySelector('.drawer__inner');
        const currentDrawerInner = drawer.querySelector('.drawer__inner');
        if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.replaceWith(newDrawerInner.cloneNode(true));
        }

        const newIconSection = iconDoc.querySelector('.shopify-section');
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (newIconSection && cartIconBubble) {
          cartIconBubble.innerHTML = newIconSection.innerHTML;
        }

        drawer.classList.add('is-empty');
        drawer.setHeaderCartIconAccessibility?.();

        const emptyContainer = drawer.querySelector('.drawer__inner-empty');
        if (emptyContainer && typeof trapFocus === 'function') {
          trapFocus(emptyContainer, emptyContainer.querySelector('a, button'));
        }
      })
      .catch((err) => {
        if (document.getElementById('CartDrawer-CartErrors')) {
          document.getElementById('CartDrawer-CartErrors').textContent =
            window.cartStrings?.error || 'Something went wrong. Please try again.';
        }
        console.error('Cart clear failed:', err);
      })
      .finally(() => {
        if (clearBtn) {
          clearBtn.removeAttribute('aria-busy');
          clearBtn.disabled = false;
        }
      });
  }

  function setupMenuDrawerCartLink(cartDrawer) {
    const cartLink = document.getElementById('menu-drawer-cart-link');
    if (!cartLink) return;

    cartLink.addEventListener('click', (e) => {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      e.preventDefault();

      const menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
      if (menuDrawerDetails?.hasAttribute('open')) {
        menuDrawerDetails.querySelector('summary')?.click();
      }

      cartDrawer.open(cartLink);
    });
  }

  function init() {
    applyBevimiLabels();
    hideDefaultVariantDl();

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    setupMenuDrawerCartLink(drawer);

    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-clear]')) {
        e.preventDefault();
        clearCart();
      }
    });

    const observer = new MutationObserver(() => {
      applyBevimiLabels();
      hideDefaultVariantDl();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
